import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { getCategories } from './salesforce_api_context';
import categoryData from '../data/categories/categories.json'
import { GET_CATEGORIES_BEGIN, GET_CATEGORIES_FAILURE, GET_CATEGORIES_SUCCESS } from '../constants/actions';

// third-party
import { useDispatch, useSelector } from "react-redux";

//  Create context
export const CategoriesContext = createContext();

export const CategoriesProvider = (props) => {

    // Reading stroe data
    const state = useSelector(state => state.category);

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant fuctions

    // Fucntion to getting all categories
    const fetchCategories = async () => {

        try {

            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_CATEGORIES_BEGIN, payload: true });

            // Calling API to get Categories
            let response = await getCategories();
            // let response = categoryData;

            // Dispatching the actions on success
            dispatch({ type: GET_CATEGORIES_SUCCESS, payload: response });

            // Showing the toast message on getting categories successfully
            // showToast("success", "Getting categories successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("43 : categories_context : Error while getting all categories::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_CATEGORIES_FAILURE, payload: error && error.message });
            
            // Showing the toast message on getting all categories unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get categories!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    }
    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <CategoriesContext.Provider value={{ ...state, fetchCategories }}>
            {props.children}
        </CategoriesContext.Provider>
    )
}
export const useCategoriesContext = () => {
    return useContext(CategoriesContext)
}
